<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Load KPIs/PSIs List Into Project</h1>
      <p>
        The user can load data into a project using a previously uploaded "list". The process of uploading a list
        using a CSV file is presented in section "<b>Various / c. Upload a project with file</b>". Please refer to that page
        of the manual for details. This page assumes that at least one list has been uploaded to USE using the described
        process. This functionality is useful for users that prefer to compile their data in a file and then automatically
        create a project using this data, instead of going through the process of filling the KPI and/or PSI forms.
      </p>

      <p>
        To use an uploaded list, the user must first create a new, empty project. Then, in the projects table, the new
        project should be located and the button with the <i class="fas fa-upload"/> icon should be clicked. After clicking
        the button a modal will appear in the screen prompting the user to select a "method" and a "list". In the first
        selection the user can select if they prefer to load a list that contains the KPIs or the PSIs of the project.
        After selecting the method, the preferred list should be selected in the selection below. The lists that appear
        in the second selection are those that the user has previously uploaded using the process described in section
        "<b>Various / c. Upload a project with file</b>". After the selections have been made, the user can click the "Load"
        button to start loading the uploaded list into the new project.
      </p>

      <div class="image-container">
        <v-row>
          <v-col>
            <img src="@/images/manual/projects-page-load-kpis-psis.png" alt="load kpi psi into project button" />
          </v-col>
          <v-col>
            <img src="@/images/manual/load-kpis-psis-modal.png" alt="load kpi psi into project" />
          </v-col>
        </v-row>

        <div class="img-caption">
          Figure 1. The Load button (left) and the load prompt (right).
        </div>
      </div>

      <p>
        After the process is completed the new project will have been filled with the KPIs or PSIs and their details
        automatically and it should be ready for analysis (given that the uploaded data were complete and valid).
      </p>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
  p {
    margin-top: 0.75rem;
  }
</style>
